module.exports = __webpack_public_path__ + "img/cn.cb85babd.svg";